import React, { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";

interface ToolCallDisplayProps {
  toolCall: {
    id?: string;
    name?: string;
    parameters?: string | Record<string, any>;
  };
}

export function ToolCallDisplay({ toolCall }: ToolCallDisplayProps) {
  const [expanded, setExpanded] = useState(false);
  const params = toolCall.parameters;
  const hasParams =
    params !== undefined &&
    params !== null &&
    (typeof params === "string" ? params.length > 0 : Object.keys(params).length > 0);
  const paramsStr =
    typeof params === "string"
      ? params
      : params != null
        ? JSON.stringify(params, null, 2)
        : "";
  const preview =
    paramsStr.length > 120 ? paramsStr.slice(0, 120) + "…" : paramsStr;

  return (
    <div className="space-y-2">
      {toolCall.name && (
        <div className="text-sm font-medium text-foreground">{toolCall.name}</div>
      )}
      {toolCall.id && (
        <div className="text-xs text-muted-foreground">
          Call ID: <code className="bg-muted px-1 rounded">{toolCall.id}</code>
        </div>
      )}
      {hasParams && (
        <div className="border border-border rounded-md overflow-hidden bg-muted">
          <button
            onClick={() => setExpanded(!expanded)}
            className="w-full flex items-center justify-between px-3 py-2 text-left text-xs font-medium text-muted-foreground hover:bg-accent transition-colors"
          >
            <span className="font-mono truncate">{preview}</span>
            {expanded ? (
              <ChevronUpIcon className="w-4 h-4 shrink-0 ml-2" />
            ) : (
              <ChevronDownIcon className="w-4 h-4 shrink-0 ml-2" />
            )}
          </button>
          {expanded && (
            <div className="px-3 py-2 border-t border-border bg-card">
              <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-2">
                Parameters
              </p>
              <pre className="text-xs text-foreground overflow-x-auto max-h-48 overflow-y-auto">
                {paramsStr}
              </pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
